import React, { useEffect, useState } from 'react';
import './OrganizationDetail.scss';
import InputField from '../../component/form/FormInput';
import FormSelect from '../../component/form/FormSelect';
import Button from '../../component/ui/Button';
import { useNavigate } from 'react-router-dom';
import {
	curency_dropdown,
	language_dropdown,
	physical_year_dropdown,
	timeZone_dropdown,
} from '../../utils/dropsdown';
import { useDispatch, useSelector } from 'react-redux';
import { master_data } from '../../store/action/master';
import {
	encodeEmailToToken,
	formatError,
	formatErrors,
	newObjectCreater,
	objectCreater,
} from '../../utils/controller';
import { organistation_setup } from '../../store/action/organistation';
import { toast } from 'react-toastify';
import logo from '../../assets/image/PharmaNex-logo.svg';
import logout from '../../assets/image/logout.svg';
import Cookies from 'js-cookie';
import InputSelect from '../../component/inputSelect/InputSelect';
import { getCities } from '../../services/vendor';
import useAuth from '../../hooks/useAuth';
import { fetchOnboardingMe } from '../../services/auth';
import { verifyOrgDomain } from '../../services/settings/organization';
import BackButton from '../../component/backbutton/BackButton';

const OrganizationDetail = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [organizationName, setorganizationName] = useState('');
	const [industry, setIndustry] = useState(1);
	const [organizationCountry, setorganizationCountry] = useState();
	const [state, setState] = useState('');
	const [street1, setstreet1] = useState('');
	const [street2, setstreet2] = useState('');
	const [city, setcity] = useState('');
	const [cityList, setCityList] = useState([]);
	const [zipCode, setzipCode] = useState('');
	const [subDomain, setsubDomain] = useState('');
	const [curency, setCurency] = useState('INR');
	const [language, setlanguage] = useState('english');
	const [year, setYear] = useState('April-March');
	const [timeZone, setTimeZone] = useState('(UTC+05:30) Chennai,Kolkata,Mumbai,New Delhi');
	const [inventoryStartDate, setinventoryStartDate] = useState();
	const [username, setUsername] = useState('');
	const [error, setError] = useState({});
	let masterData = useSelector((state) => state?.master?.masterData?.data);
	const countryList = newObjectCreater(masterData?.countries);
	const StateList = newObjectCreater(masterData?.states);
	const industryList = objectCreater(masterData?.industry);
	const expirationDate = new Date();
	expirationDate.setTime(expirationDate.getTime() + 12 * 60 * 60 * 1000);
	const { userOnboardingMe } = useAuth();
	const [loader, setLoader] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (subDomain.trim() !== '') {
				checkSubDomain(subDomain);
			}
		}, 500); // ⏳ wait 500ms after last keystroke

		return () => clearTimeout(timer); // ❌ cancel previous timer
	}, [subDomain]);

	const checkSubDomain = async (domain) => {
		try {
			const { organisation } = await verifyOrgDomain(domain);
			const { available } = organisation;
			var newError = { ...error };
			if (available?.available) {
				delete newError.sub_domain;
				// toast.success(available.message);
			} else {
				newError.sub_domain = available.message;
				// toast.error(available.message);
			}
			setError(newError);
		} catch (error) {
			console.log(error.message || 'Something went wrong!');
		}
	};

	function checkValidation() {
		const newError = { ...error };
		if (!industry || industry === '' || industry === undefined) {
			newError.industry = 'Please select a valid industry from the list.';
		} else {
			delete newError.industry;
		}
		if (!state || state === '' || state === undefined) {
			newError.state = 'Please select a valid state from the list.';
		} else {
			delete newError.state;
		}
		if (!organizationName || organizationName === '' || organizationName === undefined) {
			newError.organizationName = 'Please enter organisation name in the field';
		} else {
			delete newError.organizationName;
		}
		if (
			!subDomain ||
			subDomain === '' ||
			subDomain === undefined ||
			(newError.sub_domain && subDomain)
		) {
			newError.sub_domain = newError.sub_domain || 'Please enter organisation domain in the field';
		} else {
			delete newError.sub_domain;
		}
		if (!inventoryStartDate || inventoryStartDate === '' || inventoryStartDate === undefined) {
			newError.inventoryStartDate = 'Please enter inventory start date in the field';
		} else {
			delete newError.inventoryStartDate;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleOrganistionDetails = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error(
				'Something went wrong while create organisation! Please fill required fields.',
			);
		} else {
			setError({});
			setLoader(true);
			const body = {
				organization_name: organizationName,
				industry_id: Number(industry),
				country_id: Number(organizationCountry),
				state_id: Number(state),
				street_1: street1,
				street_2: street2,
				city_id: city,
				postal_code: zipCode,
				sub_domain: subDomain?.toLowerCase()?.trim(),
				currency: curency,
				language: language,
				time_zone: timeZone,
				inventory_start_date: inventoryStartDate,
				fiscal_year: year,
			};

			await dispatch(organistation_setup(body))
				.then(async (res) => {
					setLoader(false);
					if (!res?.success) {
						if (Array.isArray(res?.message)) {
							setError(formatError(res.message));
						} else {
							toast.error(res?.message || 'Failed to setup organisation');
						}
						return;
					}
					toast.success(res?.message || 'Organisation created successfully');
					await userOnboardingMe('');
				})
				.catch((err) => {
					setLoader(false);
					setError(formatError(err.message));
					toast.error(err);
				});
		}
	};

	const handleGoBack = async () => {
		try {
			localStorage.clear();
			navigate('/');
		} catch (error) {
			toast.error('Something went wrong while logout!');
		}
	};

	async function getCity(stateId) {
		try {
			var body = {
				state_id: Number(stateId),
			};
			var res = await getCities(body);
			if (res?.success) {
				var cities = newObjectCreater(res?.data);
				setCityList(cities);
			}
		} catch (error) {
			toast.error(error);
		}
	}

	const loadDraft = async () => {
		try {
			const data = await fetchOnboardingMe();
			const draft_org = data.data;
			const status = draft_org.onboarding_status;

			if (status === 'COMPLETED') {
				navigate(`/user/${draft_org.sub_domain}/home`);
			}

			if (draft_org) {
				setorganizationName(draft_org.organisation_name);
				setorganizationCountry(draft_org.country_id);
				setState(draft_org.state_id);
				setUsername(draft_org?.first_name + ' ' + draft_org?.last_name);
			}
		} catch (err) {
			toast.error('Failed to load organisation draft');
		}
	};

	useEffect(() => {
		getCity(state);
	}, [state]);

	useEffect(() => {
		if (localStorage.getItem('authToken')) {
			loadDraft();
			dispatch(master_data());
		} else {
			navigate('/');
		}
	}, []);

	useEffect(() => {
		setsubDomain(organizationName?.toLowerCase()?.split(/[\s\W]+/)?.[0]);
		document.title = 'Organisation Detail | Pharmnex';
	}, [organizationName]);

	return (
		<div>
			<div
				className="navtop ms-0 w-100 d-none d-md-block"
				style={{ zIndex: '1000' }}
			>
				<div className="nav-container">
					<div className="input-group form-mobile-check left-search w-auto">
						<img
							src={logo}
							alt="mdo"
							width="130"
							height=""
						/>
					</div>
					<div
						className="font-medium"
						style={{ fontSize: '1.6rem' }}
					>
						Setup your Organisationprofile
					</div>
					<div className="right-details">
						<span className="welcomeText">
							Hey! <span className="currentName">Welcome! {username}</span>
						</span>
						<img
							src={logout}
							alt="mdo"
							width=""
							height="20"
							style={{ cursor: 'pointer' }}
							onClick={handleGoBack}
						/>
					</div>
				</div>
			</div>
			<div className="organizationDetail-form">
				<div className="organizationDetail-body clearfix">
					<div className="right-section  position-relative">
						<form className="form-body">
							<div className="d-flex justify-content-between align-items-baseline">
								<h1 className="form-title pb-0">Organisation Detail</h1>
								<div className="">
									<BackButton />
								</div>
							</div>
							<div
								className="d-block d-md-none"
								style={{ fontFamily: 'Inter' }}
							>
								<div
									className="font-bold"
									style={{
										textAlign: 'center',
										color: '#3D3D3D',
										fontFamily: 'Inter',
										fontSize: '22px',
										fontStyle: 'normal',
										fontWeight: 600,
									}}
								>
									Setup Organisation profile
								</div>

								<h1
									className="text-center font-medium pt-1"
									style={{
										color: '#3D3D3D',
										textAlign: 'center',
										fontFamily: 'Inter',
										fontStyle: 'normal',
										fontWeight: 600,
									}}
								>
									Organisation Detail
								</h1>
							</div>
							<div className="row mt-5 mt-md-0">
								<div className="col-12 col-md-6 mb-3">
									<InputField
										type="text"
										placeholder="Enter your Organisation/Company name"
										label="Organisation Name"
										onChange={(value) => setorganizationName(value)}
										value={organizationName}
										name={'organization_name'}
										error={error?.organization_name}
										autoFocus={true}
										required={true}
									/>
								</div>
								<div className="col-12 col-md-6 mb-3">
									<FormSelect
										label="Industry"
										placeholder="Information Technology"
										onChange={(value) => setIndustry(value)}
										value={industry}
										options={industryList}
										name={'industry_id'}
										error={error?.industry}
										required={true}
									/>
								</div>
								<div className="col-12 col-md-6 mb-3">
									<InputSelect
										label="Organisation Country"
										placeholder="India"
										onSelect={(value) => setorganizationCountry(value.value)}
										value={organizationCountry}
										options={countryList}
										disabled={true}
										name={'country_id'}
										error={error?.country_id}
										required={true}
									/>
								</div>
								<div className="col-12 col-md-6 mb-3">
									<InputSelect
										label="State/Union Territory"
										placeholder="Select State"
										onSelect={(value) => setState(value.key)}
										value={state}
										options={StateList}
										name={'state_id'}
										error={error?.state ? 'is not allowed to be empty.' : ''}
										required={true}
									/>
								</div>
								<div className="col-12 col-md-6 mb-3">
									<InputField
										type="text"
										placeholder="Street 1"
										label="Street1"
										onChange={(value) => setstreet1(value)}
										value={street1}
										name={'street_1'}
										error={error?.street_1}
									/>
								</div>
								<div className="col-12 col-md-6 mb-3">
									<InputField
										type="text"
										value={street2}
										placeholder="Street 2"
										label="Street2"
										onChange={(value) => setstreet2(value)}
										name={'street_2'}
										error={error?.street_2}
									/>
								</div>
								<div className="col-12 col-md-6 mb-3">
									<InputSelect
										label="City"
										placeholder="Select City"
										onSelect={(value) => setcity(value.key)}
										value={city}
										options={cityList}
										disabled={false}
										name={'city_id'}
										error={error?.city}
									/>
								</div>
								<div className="col-12 col-md-6 mb-3">
									<InputField
										type="text"
										value={zipCode}
										placeholder="ZIP/Postal Code"
										label="ZIP/Postal Code"
										onChange={(value) => setzipCode(value)}
										name={'postal_code'}
										error={error?.postal_code}
									/>
								</div>
								<div className="col-12">
									<label className="form-label">Setup organization URL</label>
									<span style={{ color: 'red' }}>*</span>
									<div className="input-group ">
										<div className="input-group-append">
											<span
												className="input-group-text font-medium"
												style={{
													minHeight: '36px',
													fontSize: '1.4rem',
													// marginLeft: '.1rem',
													// minWidth: '5rem',
													justifyContent: 'center',
													color: 'var(--brand-color)',
													borderRadius: ' 8px 0 0 8px',
												}}
											>
												www.app.pharmnex.app/
											</span>
										</div>
										<input
											style={{
												borderRadius: '8px',
												borderTopLeftRadius: '0px',
												borderBottomLeftRadius: '0px',
												border: error?.sub_domain
													? '1px solid red'
													: '1px solid rgba(85, 91, 103, 0.15)',
												backgroundColor: '#FCFCFC',
												padding: '8px',
												borderLeft: '0',
											}}
											type="text"
											className="form-control"
											id="inlineFormInputGroup"
											placeholder="thewaltdesinycompany"
											onChange={(e) => {
												setsubDomain(e?.target?.value);
											}}
											value={subDomain}
											label="Create your sub domain"
											name={'sub_domain'}
											error={error?.sub_domain}
										/>
									</div>
								</div>
								{error && (
									<div
										className="error-text"
										style={{
											color: 'red',
											fontSize: '12px',
											// marginBottom: '10px',
										}}
									>
										{error?.sub_domain}
									</div>
								)}
							</div>

							<div className="d-flex justify-content-center justify-content-md-between align-items-baseline pb-4">
								<h1 className="font-bold pb-0 text-center text-md-start">Regional Details</h1>
							</div>

							<div className="row">
								<div className="col-12 col-md-6 mb-3">
									<FormSelect
										label="Currency"
										placeholder="INR - Indian Rupee"
										onChange={(value) => setCurency(value)}
										value={curency}
										options={curency_dropdown}
										name={'currency'}
										error={error?.curency}
										className="inputDarkBG"
										disabled={true}
										required={true}
									/>
								</div>
								<div className="col-12 col-md-6 mb-3">
									<FormSelect
										label="Language"
										placeholder="English"
										onChange={(value) => setlanguage(value)}
										value={language}
										options={language_dropdown}
										name={'language'}
										error={error?.language}
										className="inputDarkBG"
										disabled={true}
										required={true}
									/>
								</div>
								<div className="col-12">
									<FormSelect
										label="Time Zone"
										placeholder="(GMT 5:30) India Standard Time (Asia/Calcutta)"
										onChange={(value) => setTimeZone(value)}
										value={timeZone}
										options={timeZone_dropdown}
										name={'time_zone'}
										error={error?.time_zone}
										className="inputDarkBG"
										disabled={true}
										required={true}
									/>
								</div>
								<div className="col-12 col-md-6 mb-3">
									<InputField
										type="Date"
										placeholder="303705"
										label="Inventory Start Date"
										onChange={(value) => setinventoryStartDate(value)}
										value={inventoryStartDate}
										name={'inventory_start_date'}
										error={error?.inventory_start_date}
										required={true}
									/>
								</div>
								<div className="col-12 col-md-6 mb-3">
									<FormSelect
										label="Fiscal Year"
										placeholder="April-March"
										onChange={(value) => setYear(value)}
										value={year}
										options={physical_year_dropdown}
										name={'fiscal_year'}
										error={error?.fiscal_year}
										className="inputDarkBG"
										disabled={true}
										required={true}
									/>
								</div>
								<div className="col-12">
									<p className="">
										<span className="font-bold me-1">Notes:</span>You can update some of these
										preference from Settings anytime.
									</p>
								</div>
							</div>
							<div className="col-12 col-md-2 m-auto mt-4">
								<span className="">
									<Button
										type="button"
										className="btn-primary"
										button="Get Started"
										loader={loader}
										disabled={loader}
										onClick={handleOrganistionDetails}
									></Button>
								</span>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OrganizationDetail;
